<div class="layout-col full">
  <mat-toolbar elderTheme class="layout-row place-start-center gap-sm">
    <button mat-icon-button matDialogClose>
      <mat-icon>close</mat-icon>
    </button>

    <span>{{ 'orders.prod.list.select' | translate }}</span>
  </mat-toolbar>

  <div class="layout-col flex place-between-start p-lg">
    <mat-form-field elderDense>
      <elder-select
        appProductionListConfSelect
        [scopes]="scopes"
        name="confId"
        required
        valueAsId
        [(value)]="selection"
        placeholder="{{ 'orders.prod.list.title' | translate }}"
      >
        <div class="layout-col text-body-medium" *elderSelectValue="let value">
          <span>{{ value?.nameI18n | i18nPick$ | async }}</span>
          <span>{{ 'prod_list_scope.' + value?.scope | translate }}</span>
        </div>
      </elder-select>
    </mat-form-field>

    <div class="layout-row">
      <button mat-button (click)="onConfirm($event)">
        {{ 'actions.select' | translate }}
      </button>
    </div>
  </div>
</div>
